export enum Provinces {
  AB = 'AB',
  BC = 'BC',
  MB = 'MB',
  NB = 'NB',
  NL = 'NL',
  NT = 'NT',
  NS = 'NS',
  NU = 'NU',
  ON = 'ON',
  PE = 'PE',
  QC = 'QC',
  SK = 'SK',
  YT = 'YT',
}

export const PROVINCE_DEFAULT = Provinces.ON;

export enum Languages {
  EN = 'en',
  FR = 'fr',
}

export interface Segment {
  id: string;
  segment: string;
}

export const SEGMENT_DEFAULT = 'default';
